// paginate array and calculate total number of pages
export const usePagination = <T>(items: T[], page: number, pageSize: number = 10): { items: T[], pages: number } => {

  const pages = Math.ceil(items.length / pageSize);
  
  // clamp page into allowed interval
  if (page < 1) {
    page = 1;
  }
  if (page > pages) {
    page = pages;
  }
  
  return { items: items.slice((page - 1) * pageSize, page * pageSize), pages };
};
